import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestExpedicaoMalha } from 'src/app/@shared/models/controle-expedicao-malha.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtros = (obj: RequestExpedicaoMalha) => {
  const filtro = Object.entries(obj).filter(([k, v]) =>  v || v == 0);
  return new URLSearchParams(filtro);
}

@Injectable({
  providedIn: 'root'
})
export class ControleExpedicaoMalhaService {

  constructor(private http: HttpClient) { }

  public ExportarExcel(obj: RequestExpedicaoMalha): Observable<any[]> {
    return this.http.get<any[]>(
      `ControleExpedicaoMalha/ExportarExcel?${filtros(obj)}`, httpOptions);
  };

  public listarRegionais(): Observable<any[]> {
    return this.http.get<any[]>(
      `ControleExpedicaoMalha/ListarRegionais`, httpOptions);
  };
  public listarRotas(obj): Observable<any[]> {
    return this.http.get<any[]>(
      `ControleExpedicaoMalha/ListarRota?${filtros(obj)}`, httpOptions);
  };
  public listarIatas(regionalId: number,): Observable<any[]> {
    return this.http.get<any[]>(
      `ControleExpedicaoMalha/ListarIatas/${regionalId}`, httpOptions);
  };
  public listarGrid(obj: RequestExpedicaoMalha): Observable<any[]> {
    return this.http.get<any[]>(
      `ControleExpedicaoMalha/ListarGrid?${filtros(obj)}`, httpOptions);
  };
}
